<form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
  <div style="overflow-y: scroll">
    @if (form().startRental?.schedule || form().endRental?.schedule) {
      <div style="display: flex; justify-content: space-between; margin-bottom: .5rem;">
        <div class="rental-schedule-container">
          <strong class="label-header">{{'rentalPointsSelection.startRentalDate' | translate}}</strong>
          <span>{{ form().from | date: 'dd MMMM yyyy' : undefined : lang() }}</span>
          <strong class="label-header">{{ 'rentalPointsSelection.startRentalPoint' | translate }}</strong>
          <span>{{ form().startRental?.translations?.[lang()] || form().startRental?.businessName }}</span>
          <hr>
          @if (form().startRental?.schedule) {
            <app-schedule [rentalPoint]="form().startRental" [date]="form().from" [onNewLine]="smallWidth"/>
          }
        </div>
        <div style="text-align: right" class="rental-schedule-container">
          <strong class="label-header">{{'rentalPointsSelection.endRentalDate' | translate}}</strong>
          <span>{{ form().to | date: 'dd MMMM yyyy' : undefined : lang() }}</span>
          <strong class="label-header">{{ 'rentalPointsSelection.endRentalPoint' | translate }}</strong>
          <span>{{ form().endRental?.translations?.[lang()] || form().endRental?.businessName }}</span>
          <hr>
          @if (form().endRental?.schedule) {
            <app-schedule [rentalPoint]="form().endRental" [date]="form().from" [onNewLine]="smallWidth"/>
          }
        </div>
      </div>
      <span class="label-header" style="display: flex;">
        <strong>{{ 'rentalDays' | translate }}:</strong> {{ form().durationInDays }}
      </span>
      <app-spacer/>
    }
    <div class="order-resume-container">
      <div class="order-resume-wrapper">
        <app-order-resume/>
      </div>
    </div>
  </div>
  <app-spacer/>
  <div class="row">
    <button kendoButton
      class="payment-button"
      themeColor="primary"
      type="button"
      size="large"
      [fillMode]="chosenButton ? 'solid' : 'outline'"
      (click)="confirmReservation()">
      {{ 'bookingHandler.inStorePayment.title' | translate }}
    </button>
    <button kendoButton
      class="payment-button"
      themeColor="primary"
      size="large"
      type="button"
      [fillMode]="chosenButton ? 'outline' : (chosenButton === false ? 'solid' : 'outline')"
      (click)="setReservationMethod(false)">
      {{ 'bookingHandler.onlinePayment.title' | translate }} (-2%)
    </button>
  </div>
  @if (formGroup.invalid && !formGroup.untouched) {
    <kendo-formerror style="justify-content: center" [textContent]="'paymentSelection.error' | translate"/>
  }
</form>
<div kendoDialogContainer></div>
